import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserFacade } from '../../../../../../store/user/user.facade';
import { CartFacade } from '../../../../../../store/cart';
import { DataAttributeDirective } from '@shared/directives/data-attribute.directive';
import { LogoComponent } from '../../../logo/logo.component';
import { SearchBarComponent } from '../../../search-bar/search-bar.component';
import { UserActionsComponent } from '../header-user-info/components/user-actions/user-actions.component';
import { NotificationBellComponent } from '../header-user-info/components/notification-bell/notification-bell.component';
import { CatalogButtonComponent } from '../catalog-button/catalog-button.component';
import { HeaderSearchBaseComponent } from '../../base/header-search-base/header-search-base.component';
import { ShowOnPlatformNarrowDirective } from '@shared/directives/show-on-platform-narrow.directive';
import { ManagerDialogConstructor } from '@services/utils/manager-dialog-constructor.service';
import { ManagerInfoComponent } from '../manager-info/manager-info.component';

@Component({
  selector: 'b2b-portal-header-search',
  templateUrl: './header-search.component.html',
  styleUrls: ['./header-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CartFacade, UserFacade, ManagerDialogConstructor],
  imports: [
    DataAttributeDirective,
    LogoComponent,
    SearchBarComponent,
    UserActionsComponent,
    NotificationBellComponent,
    CatalogButtonComponent,
    ShowOnPlatformNarrowDirective,
    ManagerInfoComponent,
  ],
})
export class HeaderSearchComponent extends HeaderSearchBaseComponent {}
